import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import compose from "ramda/src/compose"

import Loading from "components/Loading"

import ENV from "../../envProperties"
import {
  redirectToAuthorization,
  authenticate,
  saveOperation,
  getCustomer,
  logout
} from "services/state/actions"
import { killSession } from "services/network/auth"

const APP_BASENAME = "/AreaClienteCorporativo"
const AUTH_REDIRECT_FLAG = "bffAuthRedirectInProgress"

class Login extends Component {
  componentDidMount() {
    window.sessionStorage.removeItem(AUTH_REDIRECT_FLAG)
  }

  getReturnToPath() {
    const returnTo = window.sessionStorage.getItem("postLoginRedirectPath")

    if (!returnTo) {
      return "/"
    }

    const normalizedReturnTo = returnTo.startsWith(APP_BASENAME)
      ? returnTo.slice(APP_BASENAME.length) || "/"
      : returnTo

    if (!normalizedReturnTo.startsWith("/")) {
      return "/"
    }

    return normalizedReturnTo
  }

  clearReturnToPath() {
    window.sessionStorage.removeItem("postLoginRedirectPath")
  }

  redirectToAuthorization() {
    this.props.redirectToAuthorization(
      window.location.href.replace("/login", "/callback")
    )
  }

  async validateCustomer() {
    try {
      const response = await this.props.getCustomer()

      if (response && response.payload.data) {
        const data = response.payload.data
        const customerSegment = data.customerSegment
        const documentNumber = data.documentNumber

        if (customerSegment === "CORPORATIVO" || documentNumber.length >= 14) {
          const returnTo = this.getReturnToPath()
          this.clearReturnToPath()
          this.props.history.push(returnTo)
        } else {
          this.clearReturnToPath()
          logout()
          killSession()

          this.doIdentityServerLogoff()
        }
      }
    } catch (error) {
      console.error("Error fetching customer data", error)
    }
  }

  authenticate(code, state, redirectUri) {
    const isConsultant = window.location.href.includes("/autenticacao.html")

    this.props.authenticate(
      { code, state, redirectUri },
      () => {
        isConsultant &&
          this.props.saveOperation(
            this.props.customer,
            "",
            "LOGIN_CONSULTANT-SUCCESS",
            "LOGIN CONSULTOR",
            "SUCCESS",
            "",
            "SUCESSO LOGIN CONSULTOR"
          )

        this.validateCustomer()
      },
      (data) => {
        console.error(data)
      }
    )
  }

  doIdentityServerLogoff() {
    window.location.replace(
      `${ENV.BFF}/auth/oauth2/logout?location=${window.location.origin}`
    )
  }

  render() {
    if (!this.props.isAuthenticationStep && !this.props.logOff) {
      this.redirectToAuthorization()
    } else if (this.props.logOff) {
      killSession()
      this.doIdentityServerLogoff()
    } else if (
      !this.props.loadingAuthenticationStep &&
      !this.props.authenticated
    ) {
      this.authenticate(
        this.props.code,
        this.props.state,
        this.props.redirectUri
      )
    }

    return <Loading isOpen={true} />
  }
}

Login.propTypes = {
  isAuthenticationStep: PropTypes.bool,
  logOff: PropTypes.bool,
  authenticated: PropTypes.bool,
  code: PropTypes.string,
  state: PropTypes.string,
  redirectUri: PropTypes.string,
  loadingAuthenticationStep: PropTypes.bool,
  customer: PropTypes.object,
  redirectToAuthorization: PropTypes.func,
  authenticate: PropTypes.func,
  saveOperation: PropTypes.func,
  getCustomer: PropTypes.func,
  history: PropTypes.object,
  location: PropTypes.object
}

function mapStateToProps(state) {
  const {
    auth: { authenticated, error, loadingAuthenticationStep },
    customer
  } = state
  return { authenticated, hasError: error, loadingAuthenticationStep, customer }
}

const enhance = compose(
  withRouter,
  translate(),
  connect(mapStateToProps, {
    redirectToAuthorization,
    authenticate,
    saveOperation,
    getCustomer
  })
)

export default enhance(Login)



// WEBPACK FOOTER //
// ./src/scenes/Login/index.js